import { BooleanInput } from "@angular/cdk/coercion";
import { Directive, InputSignal, InputSignalWithTransform, WritableSignal } from "@angular/core";
import { AbstractControlDirective, NgControl } from "@angular/forms";
import { Observable } from "rxjs";

@Directive()
export abstract class VdsFormFieldControl<T> {
    /** The value of the control. */
    value!: T | null;

    /** Stream that emits whenever the state of the control changes such that the parent `VdsFormField` needs to run change detection. */
    readonly stateChanges!: Observable<void>;

    /** The element ID for this control. */
    readonly id!: InputSignal<string>;

    /** The placeholder for this control */
    readonly placeholder!: InputSignal<string | undefined>;

    /** Gets the AbstractControlDirective for this control. */
    readonly ngControl!: NgControl | AbstractControlDirective | null;

    /** Whether the control is focused. */
    readonly focused!: WritableSignal<boolean>;

    /** Whether the control is empty. */
    readonly empty!: boolean;

    /** Whether the control is required. */
    readonly required!: boolean;

    /** Whether the control is disabled. */
    readonly disabledState!: WritableSignal<boolean>;

    /** Whether the control is readonly. */
    readonly isReadonly!: InputSignalWithTransform<boolean, BooleanInput>;

    /** Whether the control is in an error state. */
    readonly errorState!: () => boolean;

    readonly userAriaDescribedBy?: InputSignal<string>;

    readonly setDescribedByIds!: (ids: string[]) => void;

    /** Clears the control value when supported by the control. */
    clear?(): void;

    abstract onContainerClick(event: MouseEvent): void;
}
